var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.771 19.0832H16.2502C16.6259 19.0832 16.9862 18.9339 17.2519 18.6682C17.5176 18.4026 17.6668 18.0422 17.6668 17.6665V9.16651C17.6674 8.94204 17.6235 8.71969 17.5376 8.51229C17.4518 8.30488 17.3258 8.11653 17.1667 7.95809L14.6252 5.41659C14.4668 5.25759 14.2785 5.13153 14.0711 5.0457C13.8636 4.95987 13.6413 4.91596 13.4168 4.91651H7.75016C7.37444 4.91651 7.0141 5.06576 6.74843 5.33144C6.48275 5.59712 6.3335 5.95745 6.3335 6.33318V9.02484",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4165 4.9165V8.45817C13.4165 8.64603 13.4911 8.8262 13.624 8.95904C13.7568 9.09188 13.937 9.1665 14.1248 9.1665H17.6665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7877 13.5581L8.45856 15.5414L5.12939 13.5581",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62489 12.7792C5.40673 12.9053 5.22614 13.0873 5.10176 13.3065C4.97737 13.5256 4.91369 13.774 4.91727 14.0259V16.3209C4.90899 16.5732 4.96825 16.823 5.08892 17.0447C5.2096 17.2664 5.38729 17.4518 5.60364 17.5817L7.74989 18.8709C7.96713 19.0003 8.21503 19.0692 8.46788 19.0704C8.72073 19.0717 8.96931 19.0052 9.18781 18.878L11.2916 17.5959C11.5099 17.4699 11.6906 17.288 11.8151 17.0688C11.9396 16.8497 12.0034 16.6013 11.9999 16.3492V14.0542C12.0081 13.8019 11.9487 13.552 11.8279 13.3303C11.7071 13.1087 11.5293 12.9233 11.3128 12.7934L9.16656 11.5042C8.94932 11.3748 8.70141 11.306 8.44857 11.3047C8.19572 11.3035 7.94714 11.3699 7.72864 11.4972L5.62489 12.7792Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4585 15.5415V19.0832",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMode);
export default __webpack_public_path__ + "static/media/DefaultMode.39d0326981b93b33397b94bfbf48d61f.svg";
export { ForwardRef as ReactComponent };